/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDeliverFeeKrRespVo } from './GetDeliverFeeKrRespVo';
import {
    GetDeliverFeeKrRespVoFromJSON,
    GetDeliverFeeKrRespVoFromJSONTyped,
    GetDeliverFeeKrRespVoToJSON,
    GetDeliverFeeKrRespVoToJSONTyped,
} from './GetDeliverFeeKrRespVo';

/**
 * 
 * @export
 * @interface ResponseGetDeliverFeeKrRespVo
 */
export interface ResponseGetDeliverFeeKrRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseGetDeliverFeeKrRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseGetDeliverFeeKrRespVo
     */
    message?: string;
    /**
     * 
     * @type {GetDeliverFeeKrRespVo}
     * @memberof ResponseGetDeliverFeeKrRespVo
     */
    data?: GetDeliverFeeKrRespVo;
}

/**
 * Check if a given object implements the ResponseGetDeliverFeeKrRespVo interface.
 */
export function instanceOfResponseGetDeliverFeeKrRespVo(value: object): value is ResponseGetDeliverFeeKrRespVo {
    return true;
}

export function ResponseGetDeliverFeeKrRespVoFromJSON(json: any): ResponseGetDeliverFeeKrRespVo {
    return ResponseGetDeliverFeeKrRespVoFromJSONTyped(json, false);
}

export function ResponseGetDeliverFeeKrRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetDeliverFeeKrRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : GetDeliverFeeKrRespVoFromJSON(json['data']),
    };
}

export function ResponseGetDeliverFeeKrRespVoToJSON(json: any): ResponseGetDeliverFeeKrRespVo {
    return ResponseGetDeliverFeeKrRespVoToJSONTyped(json, false);
}

export function ResponseGetDeliverFeeKrRespVoToJSONTyped(value?: ResponseGetDeliverFeeKrRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': GetDeliverFeeKrRespVoToJSON(value['data']),
    };
}

